export default __webpack_public_path__ + "static/protocol-1-c189e0e76c7186856a69f020ec0969e2.png";